import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthModule } from '../auth/auth.module';
import { AppLinkNavigatorService } from './appLinks/appLinkNavigator.service';
import { AppLinksCfgService } from './appLinks/appLinksCfg.service';
import { ErrorDialogNotifierService } from './errorHandling/errorDialogNotifier.service';
import { ErrorPageComponent } from './errorHandling/errorPage.component';
import { HeaderComponent } from './header/header.component';
import { HelpComponent } from './help/help.component';
import { HelpCfgService } from './help/helpCfg.service';
import { AppSelectionDialogComponent } from './launcher/appSelectionDialog.component';
import { LauncherComponent } from './launcher/launcher.component';
import { LauncherAppCardComponent } from './launcher/launcherAppCard.component';
import { LauncherCfgService } from './launcher/launcherCfg.service';
import { LauncherMobileComponent } from './launcher/launcherMobile.component';
import { LoggerService } from './logging/logger.service';
import { LoggerCfgService } from './logging/loggerCfg.service';
import { MultiviewComponent } from './multiview/multiview.component';
import { MultiviewContentDirective } from './multiview/multiviewContent.directive';
import { NgbDateParserFormatterES } from './ngBootstrap/ngbDateParserFormatterES';
import { OfficeSelectorComponent, OfficeSelectorFilterCompany, OfficeSelectorFilterOffice } from './officeSelector/officeSelector.component';
import { OfficeSelectorService } from './officeSelector/officeSelector.service';
import { OfficeSelectorCfgService } from './officeSelector/officeSelectorCfg.service';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SmsService } from './sms/sms.service';
import { SmsCfgService } from './sms/smsCfg.service';
import { UserInfoComponent } from './userInfo/userInfo.component';
import { SmsTemplateRepositoryService } from './sms/smsTemplateRepository.service';
import { LoadManagerService } from './loadingOverlay/loadManager.service';
import { ImpersonationMenuComponent } from './impersonationMenu/impersonationMenu.component';
import { NotificationHubService } from './notificationHub/notificationHub.service';
import { NotificationHubCfgService } from './notificationHub/notificationHubCfg.service';
import { HeaderCfgService } from './header/headerCfg.service';
import { CommonCfgService } from './rest/common-cfg.service';
import { DialogModule } from './dialog.module';
import { LoadingOverlayModule } from './loading-overlay.module';
import { PowerBiDialogComponent } from './launcher/powerbi/components/powerbi-dialog/powerbi-dialog.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { PowerBiCfgService } from './launcher/powerbi/services/powerbi-cfg.service';
import { ShowPowerBiCfgService } from './launcher/powerbi/services/showPowerbi-cfg.service';

@NgModule({
    imports: [
        BrowserAnimationsModule,
        AuthModule,
        FormsModule,
        DialogModule,
        LoadingOverlayModule,
        NgbModule,
        PowerBIEmbedModule
    ],
    declarations: [
        HeaderComponent,
        LauncherComponent,
        LauncherMobileComponent,
        AppSelectionDialogComponent,
        PowerBiDialogComponent,
        LauncherAppCardComponent,
        UserInfoComponent,
        OfficeSelectorComponent,
        OfficeSelectorFilterCompany,
        OfficeSelectorFilterOffice,
        HelpComponent,
        PageNotFoundComponent,
        ErrorPageComponent,
        MultiviewComponent,
        MultiviewContentDirective,
        ImpersonationMenuComponent
    ],
    exports: [
        HeaderComponent,
        LauncherComponent,
        LauncherMobileComponent,
        AppSelectionDialogComponent,
        PowerBiDialogComponent,
        LauncherAppCardComponent,
        UserInfoComponent,
        OfficeSelectorComponent,
        OfficeSelectorFilterCompany,
        OfficeSelectorFilterOffice,
        HelpComponent,
        PageNotFoundComponent,
        ErrorPageComponent,
        MultiviewComponent,
        MultiviewContentDirective,
        ImpersonationMenuComponent,
        LoadingOverlayModule,
        DialogModule
    ],
    providers: [
        LoadManagerService,
        AppLinksCfgService,
        AppLinkNavigatorService,
        OfficeSelectorCfgService,
        OfficeSelectorService,
        HeaderCfgService,
        HelpCfgService,
        LoggerCfgService,
        LoggerService,
        LauncherCfgService,
        SmsCfgService,
        SmsService,
        SmsTemplateRepositoryService,
        NotificationHubCfgService,
        NotificationHubService,
        PowerBiCfgService,
        ShowPowerBiCfgService,
        CommonCfgService,
        {
            provide: NgbDateParserFormatter,
            useClass: NgbDateParserFormatterES
        },
        ErrorDialogNotifierService
    ]
})
export class CommonModule {

}
